module.exports = __webpack_public_path__ + "img/201109211wq8.b04ec381.jpg";